<div [id]="notificationTargetScrollTo" class="rpc-notifications">

    @let isShowOnlyUnviewedNotifications = isShowOnlyUnviewedNotifications$ | async;
    @let isHybrid = isHybrid$ | async;
    @let isMobile = isMobile$ | async;
    @let activeTab = activeTab$ | async;
    @let notifications = indexNotificationsListMap.get(activeTab) | async;

    <div class="rpc-notifications-header">

        <div class="rpc-notifications-title rpc-title-font">
            {{ 'NOTIFICATIONS.TITLES.NOTIFICATIONS' | translate}}
        </div>

        <rpc-button class="rpc-notifications-close" [iconName]="'cross'" [title]="'NOTIFICATIONS.TITLES.CLOSE'"
            (clicked)="onClose()">
        </rpc-button>

        @if ((flatNotifications$ | async).length > 0) {
        <div class="rpc-notifications-clear" (click)="onMarkAllViewed()">
            {{ 'NOTIFICATIONS.TITLES.MARK_ALL_AS_READ' | translate}}
        </div>
        }

        <rpc-slide-toggle class="rpc-notifications-toogle" [firstText]="'NOTIFICATIONS.TITLES.ONLY_SHOW_UNREAD'"
            [checked]="isShowOnlyUnviewedNotifications"
            (changed)="onShowOnlyUnviewedFilterChanged(!isShowOnlyUnviewedNotifications)">
        </rpc-slide-toggle>

        <!-- Only for mobile and PWA -->
        <rpc-select class="rpc-notifications-select" [appearance]="'fill'"
            [controlOptions]="notificationTypeControlOptions" (changed)="onNotificationTypeChanged($event)">
        </rpc-select>

    </div>

    <!-- Only for mobile and PWA -->
    @if (isMobile || isHybrid) {

    <notification-list class="rpc-notifications-main" [notifications]="notifications"
        (navigateToNotificationEntity)="onNavigateToNotificationEntity($event)">
    </notification-list>

    } @else {

    <!-- only for desktop -->
    <div class="rpc-notifications-tabs">

        <rpc-tabs class="rpc-notifications-tabs-header" [tabItems]="tabs$ | async" [value]="activeTab"
            (changed)="onSelectedTabChanged($event)">
        </rpc-tabs>

        <div class="rpc-notifications-tabs-body">

            <notification-list [notifications]="notifications"
                (navigateToNotificationEntity)="onNavigateToNotificationEntity($event)">
            </notification-list>

        </div>

    </div>

    }

</div>